import { render } from "./TestoCantico.vue?vue&type=template&id=d531b042&scoped=true"
import script from "./TestoCantico.vue?vue&type=script&lang=js"
export * from "./TestoCantico.vue?vue&type=script&lang=js"

import "./TestoCantico.vue?vue&type=style&index=0&id=d531b042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d531b042"]])

export default __exports__